<app-partner *ifRoles="['ROLE_PARTNER']"></app-partner>
<app-delivery *ifRoles="['ROLE_DELIVERY']"></app-delivery>
<app-farmer *ifRoles="['ROLE_FARMER']"></app-farmer>
<app-inventory *ifRoles="['ROLE_MANAGER']"></app-inventory>
<app-coordinator *ifRoles="['ROLE_COORDINATOR']"></app-coordinator>